import React, { useState, useEffect } from 'react';
import guitar1 from '../images/guitar1.png';

const Header1 = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [login, setLogin] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const API_URL = process.env.REACT_APP_API_URL;
  console.log("API_URL:", API_URL);
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) props.setIsLoggedIn(true);
  }, []);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
    setError('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLogin({ ...login, [name]: value });
  };

  const handleLoginClick = () => {
    if (!login.username || !login.password) {
      setError('All fields are required');
      return;
    }

    
    fetch(`${API_URL}/api-token-auth/`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: login.username, password: login.password }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json().then((data) => {
            localStorage.setItem('token', data.token);
            props.setIsLoggedIn(true);
            setIsExpanded(false);
          });
        } else {
          setError('Username or password is incorrect');
        }
      })
      .catch((err) => console.error(err));
  };

  const handleLogoutClick = () => {
    localStorage.removeItem('token');
    props.setIsLoggedIn(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img className="guitar-logo" src={guitar1} alt="Logo" />
        <span className="navbar-title">My Music App</span>
      </div>

      <div className="navbar-actions">
        {props.isLoggedIn ? (
          <button className="btn btn-outline" onClick={handleLogoutClick}>
            Logout
          </button>
        ) : (
          <div className="login-area">
            <button className="btn btn-primary" onClick={handleExpandClick}>
              {isExpanded ? '✕ Close' : 'Login'}
            </button>
            {isExpanded && (
              <div className="login-dropdown">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleLoginClick();
                  }}
                >
                  <div className="input-group">
                    <label>Login</label>
                    <input
                      type="text"
                      name="username"
                      value={login.username}
                      onChange={handleInputChange}
                      placeholder="Username"
                      autoComplete="username"
                    />
                  </div>
                  <div className="input-group">
                    <label>Hasło</label>
                    <input
                      type="password"
                      name="password"
                      value={login.password}
                      onChange={handleInputChange}
                      placeholder="••••••••"
                      autoComplete="current-password"
                    />
                  </div>
                  {error && <p className="form-error">{error}</p>}
                  <button type="submit" className="btn btn-primary btn-full">
                    Zaloguj
                  </button>
                </form>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};


function SongList(props) {
  const [songs, setSongs] = useState([]);
  const [form, setForm] = useState({ title: '', performer: '', album: '', genre: '', year: '' });
  const [error, setError] = useState('');
  const [sortCriteria, setSortCriteria] = useState('title');
  const [sortOrder, setSortOrder] = useState('asc');
  const [searchQuery, setSearchQuery] = useState('');
  const API_URL = process.env.REACT_APP_API_URL;

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCreateSong = (e) => {
    e.preventDefault();
    const { title, performer, album, genre, year } = form;
    if (!title || !performer || !album || !genre || !year) {
      setError('All fields are required');
      return;
    }
    if (isNaN(year)) {
      setError('Year must be integer');
      return;
    }
    fetch(`${API_URL}/song/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(form),
    })
      .then((res) => res.json())
      .then((data) => {
        setSongs([...songs, data]);
        setForm({ title: '', performer: '', album: '', genre: '', year: '' });
        setError('');
      })
      .catch((err) => console.error(err));
  };

  const handleDeleteSong = (id) => {
    fetch(`${API_URL}/song/${id}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('token')}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error('Nie udało się usunąć piosenki');
        setSongs(songs.filter((s) => s.id !== id));
      })
      .catch((err) => console.error(err));
  };

  const handleSort = (criteria) => {
    if (sortCriteria === criteria) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortCriteria(criteria);
      setSortOrder('asc');
    }
  };

  const sortedSongs = [...songs].sort((a, b) => {
    const dir = sortOrder === 'desc' ? -1 : 1;
    if (sortCriteria === 'year') return dir * (a.year - b.year);
    return dir * a[sortCriteria].localeCompare(b[sortCriteria]);
  });

  useEffect(() => {
      fetch(`${API_URL}/song/?search=${searchQuery}`)
        .then((res) => res.json())
        .then((data) => setSongs(data));
    }, [searchQuery]);

  const SortIcon = ({ field }) => (
    <span className={`sort-icon ${sortCriteria === field ? 'sort-active' : ''}`}>
      {sortCriteria === field ? (sortOrder === 'asc' ? ' ↑' : ' ↓') : ' ↕'}
    </span>
  );

  const fields = [
    { name: 'title', label: 'Title' },
    { name: 'performer', label: 'Performer' },
    { name: 'album', label: 'Album' },
    { name: 'genre', label: 'Genre' },
    { name: 'year', label: 'Year' },
  ];

  return (
    <main className="main-content">
      {props.isLoggedIn && (
        <section className="add-song-section">
          <h2 className="section-title">Add song</h2>
          <form className="add-song-form" onSubmit={handleCreateSong}>
            <div className="form-grid">
              {fields.map((f) => (
                <div className="input-group" key={f.name}>
                  <label>{f.label}</label>
                  <input
                    type="text"
                    name={f.name}
                    value={form[f.name]}
                    onChange={handleFormChange}
                    placeholder={f.label}
                  />
                </div>
              ))}
            </div>
            {error && <p className="form-error">{error}</p>}
            <button type="submit" className="btn btn-primary">
              + Add song
            </button>
          </form>
        </section>
      )}

      <section className="song-list-section">
        <div className="search-bar">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="🔍  Search for songs..."
            className="search-input"
          />
          {searchQuery && (
            <button className="btn btn-outline btn-sm" onClick={() => setSearchQuery('')}>
              Clear
            </button>
          )}
        </div>

        <div className="table-wrapper">
          <table className="song-table">
            <thead>
              <tr>
                {fields.map((f) => (
                  <th key={f.name} onClick={() => handleSort(f.name)} className="sortable-th">
                    {f.label}
                    <SortIcon field={f.name} />
                  </th>
                ))}
                {props.isLoggedIn && <th className="actions-th"></th>}
              </tr>
            </thead>
            <tbody>
              {sortedSongs.length === 0 ? (
                <tr>
                  <td colSpan={props.isLoggedIn ? 6 : 5} className="empty-state">
                    Songs not found
                  </td>
                </tr>
              ) : (
                sortedSongs.map((song) => (
                  <tr key={song.id} className="song-row">
                    <td>{song.title}</td>
                    <td>{song.performer}</td>
                    <td>{song.album}</td>
                    <td>
                      <span className="genre-badge">{song.genre}</span>
                    </td>
                    <td>{song.year}</td>
                    {props.isLoggedIn && (
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteSong(song.id)}
                        >
                          Remove
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
}

export { SongList, Header1 };
